import { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorState } from '../../ui/Display/Display';

/** Keeps the sidebar and topbar working if one page throws while rendering. Reset by changing `key`. */
export class PageErrorBoundary extends Component<{ children?: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Page crashed', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return <ErrorState error={{ message: 'This screen hit an unexpected problem. Reload the page or go back.' }} onRetry={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}

export default PageErrorBoundary;
